<template>
  <div>
    <v-divider v-if="index > 0"/>
    <v-list-item
        class="px-0"
    >
      <v-container class="pa-0 pa-md-2">
        <v-row no-gutters>
          <v-col
              v-if="$vuetify.display.smAndDown"
              cols="12"
          >
            <v-skeleton-loader type="heading"/>
          </v-col>
          <v-col
              v-if="$vuetify.display.smAndDown"
              cols="12"
          >
            <v-skeleton-loader type="chip@3"/>
          </v-col>
          <v-col
              cols="12"
              md="2"
              align-self="center"
          >
            <v-skeleton-loader
                class="car-item-image-skeleton-loader"
                height="150"
                type="image"
            />
          </v-col>
          <v-col
              cols="12"
              md="8"
              class="px-0 px-md-2 pt-2 pt-md-0"
          >
            <v-row
                v-if="$vuetify.display.mdAndUp"
                :no-gutters="true"
            >
              <v-col
                  align-self="center"
              >
                <v-skeleton-loader type="heading"/>
              </v-col>
            </v-row>
            <v-row :no-gutters="true">
              <v-col>
                <v-skeleton-loader type="paragraph"/>
              </v-col>
            </v-row>
          </v-col>
          <v-col
              v-if="$vuetify.display.mdAndUp"
              md="2"
          >
            <v-skeleton-loader type="heading"/>
            <v-skeleton-loader type="heading"/>
            <v-skeleton-loader type="heading"/>
          </v-col>
        </v-row>
      </v-container>
    </v-list-item>
  </div>
</template>

<script>

export default {
  name: "CarListItemSkeleton",
  props: {
    index: Number
  }
}
</script>

<style scoped>
::v-deep .car-item-image-skeleton-loader > * {
  height: 100%;
  display: flex;
  flex-direction: column;
}

::v-deep .car-item-image-skeleton-loader {
  flex-grow: 1;
}
</style>